import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tags-view-container" }

import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import ScrollPane from "./ScrollPane.vue";
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const path = require('path')
const store = useStore()
const route = useRoute()
const router = useRouter()
const routes = computed(() => {
  return store.state.permission.routes
})
const visitedViews = computed(() => {
  return store.state.tagsView.visitedViews
})
let obj = new WeakMap()

let affixTags = ref([])
const tags = ref([])
const setTagRef = (el) => {
  if (el) {
    if (!obj.get(el)) {
      tags.value.push(el)
    }
    obj.set(el, el)
  }

}

const rollPane = ref()

function filterAffixTags(routes, basePath = '/') {
  let tags = []
  routes.forEach(route => {
    if (route.meta && route.meta.affix) {
      const tagPath = path.resolve(basePath, route.path)
      tags.push({
        fullPath: tagPath,
        path: tagPath,
        name: route.name,
        meta: { ...route.meta }
      })
    }
    if (route.children) {
      const tempTags = filterAffixTags(route.children, route.path)
      if (tempTags.length >= 1) {
        tags = [...tags, ...tempTags]
      }
    }
  })
  return tags
}

const initTags = () => {
  let affixTag = affixTags.value = filterAffixTags(routes.value)
  for (const tag of affixTag) {
    if (tag.name) {
      store.dispatch('tagsView/addVisitedView', tag)
    }
  }
}
// function handleScroll() {
//   closeMenu()
// }

const isActive = (rou) => {
  return rou.path === route.path
}
const isAffix = (tag) => {
  return tag.meta && tag.meta.affix
}
const addTags = () => {
  const { name } = route
  if (name) {
    store.dispatch('tagsView/addView', route)
  }
  return false
}
function toLastView(visitedViews, view) {
  const latestView = visitedViews.slice(-1)[0]
  if (latestView) {
    router.push(latestView.fullPath)
  } else {
    if (view.name === 'home') {
      router.replace({ path: '/redirect' + view.fullPath })
    } else {
      router.push('/')
    }
  }
}

const closeSelectedTag = (view) => {
  store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
    if (isActive(view)) {
      toLastView(visitedViews, view)
    }
  })
}

function moveToCurrentTag() {
  nextTick(() => {
    for (const tag of tags.value) {
      if (tag.to.path === route.path) {
        rollPane.value.moveToTarget(tag, tags.value)
        if (tag.to.fullPath !== route.fullPath) {
          store.dispatch('tagsView/updateVisitedView', route)
        }
        break
      }
    }
  })
}


onMounted(() => {
  initTags()
  addTags()

  watch(route, () => {
    addTags()
    moveToCurrentTag()
  })
})


return (_ctx: any,_cache: any) => {
  const _component_close = _resolveComponent("close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ScrollPane, {
      ref_key: "rollPane",
      ref: rollPane,
      class: "tags-view-wrapper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visitedViews.value, (tag) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            ref_for: true,
            ref: setTagRef,
            class: _normalizeClass([isActive(tag) ? 'active' : '', "tags-view-item"]),
            key: tag.path,
            to: { path: tag.path, query: tag.query, fullPath: tag.fullPath },
            tag: "span"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.title) + " ", 1),
              (!isAffix(tag))
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (closeSelectedTag(tag)), ["prevent","stop"]),
                    style: {"vertical-align":"-10%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_close)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "to"]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})